import { Spinner } from "@bphxd/ds-core-react";
//label shows up after 5 seconds
const LoginPage: React.FC = () => {
    return (
        <>
        <div className="d-flex justify-content-center align-items-center vh-100">
          <Spinner size="lg" className="ms-3" label="Getting you logged in"/>
        </div>
      </>
    );
};
    export default LoginPage;